import * as React from 'react';
export function EmptyErrorBoundary({
  children,
}: {
  children: React.ReactNode;
}) {
  return <>{children}</>;
}
